class DataRepository {
  private readonly strategy: Storage

  constructor (strategy: Storage) {
    this.strategy = strategy
  }

  public getData (key: string): string | null {
    return this.strategy.getItem(key)
  }

  public setData (key: string, item: string): void {
    this.strategy.setItem(key, item)
  }

  public removeData (key: string): void {
    this.strategy.removeItem(key)
  }
}

export default new DataRepository(window.localStorage)
